module.exports = __webpack_public_path__ + "img/buyicon.8097ce74.svg";